import './loader.sass';

export { default } from './loader';
